import { observable, action, makeObservable } from 'mobx';
import { deliveryService } from 'config/ioc';
import { PENDING, FULFILLED, REJECTED } from 'constants/actions';

class DeliveryStore {
  fetchState;

  shipment;

  constructor() {
    makeObservable(this, {
      fetchState: observable,
      shipment: observable.ref,
      getShipment: action,
    });
  }

  async getShipment(shipmentId) {
    this.fetchState = PENDING;

    try {
      const response = await deliveryService.getShipment(shipmentId);
      const [shipment] = response.data.data.items;
      this.shipment = shipment;
      this.fetchState = FULFILLED;
    } catch (e) {
      this.fetchState = REJECTED;
    }
  }
}

const deliveryStore = new DeliveryStore();

export default deliveryStore;
